module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chp",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_c('i', {
    staticClass: "italic"
  }, [_vm._v("Old is the tree, and the fruit good")])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_c('i', {
    staticClass: "italic"
  }, [_vm._v("Very old and thick the wood.")])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_c('i', {
    staticClass: "italic"
  }, [_vm._v("Woodsman, is your courage stout?")])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_c('i', {
    staticClass: "italic"
  }, [_vm._v("Beware! The root is wrapped about")])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_c('i', {
    staticClass: "italic"
  }, [_vm._v("Your mother’s heart, your father’s bones;")])]), _vm._v(" "), _c('p', {
    staticClass: "epi"
  }, [_c('i', {
    staticClass: "italic"
  }, [_vm._v("And like the mandrake comes with groans.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—Robert Louis Stevenson, "), _c('i', {
    staticClass: "italic"
  }, [_vm._v("Fables")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eedd36fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Headhunter-8.vue
// module id = 87
// module chunks = 0